module.exports = __webpack_public_path__ + "img/image-1.819a3fcc.webp";